import {Tabs, TabsProps,Form} from "antd";
import React, {useEffect, useRef, useState} from "react";
import {useAppDispatch, useAppSelector} from "redux/hooks";
import InfoDoc from "./InfoDoc/InfoDoc";
import ListFile from "./ListFile/ListFile";
const FormAdd = props => {
  const {type,data,closeModal, getListApi} = props;
  const detailDoc = useAppSelector(state => state.employeesReducer.detailDoc);
  const [activeKey, setActiveKey] = useState<string>("info-doc");
  const [form] = Form.useForm();
  const itemsInit: TabsProps["items"] = [
    {
      key: "info-doc",
      label: `Thông tin văn bản`,
      children: <InfoDoc closeModal={closeModal} getListApi={getListApi} />,
    },
    {
      key: "list-file",
      label: `Danh sách file`,
      children: (
        <ListFile closeModal={closeModal} getListApi={getListApi} activeKey={activeKey}></ListFile>
      ),
    },
  ];
  useEffect(() => {
    const setDisableTab = () => {
      itemsInit[1].disabled = detailDoc == null;
      setItems([...itemsInit]);
    };
    const _setActiveKey = () => {
      setActiveKey("info-doc");
    };
    setDisableTab();
    _setActiveKey();
  }, [detailDoc]);
  const [items, setItems] = useState<TabsProps["items"]>(itemsInit);
  const dispatch = useAppDispatch();
  return (
    <div>
      <Tabs
        items={items}
        activeKey={activeKey}
        onChange={key => {
          setActiveKey(key);
        }}
      ></Tabs>
    </div>
  );
};

export default FormAdd;
